import { put, select, take } from 'redux-saga/effects';
import { set } from 'lodash';
import { push, replace } from 'redux-little-router';
import { getFormValues } from 'redux-form/immutable';
import { fromJS } from 'immutable';
import {
  createDraft,
  getDraft,
  refineDraft,
  submitInitialDataSuccess,
  updateDraft,
} from 'modules/Taps/components/NDFL3Light/redux/actions';
import {
  CREATE_DRAFT_SUCCESS,
  GET_DRAFT_SUCCESS,
  REFINE_DRAFT_SUCCESS,
  UPDATE_DRAFT_SUCCESS,
} from 'modules/Taps/components/NDFL3Light/redux/actionTypes';
import {
  selectDraft,
  selectDraftMode,
  selectParentDeclaration,
} from 'modules/Taps/components/NDFL3Light/selectors';
import { STEP_INITIAL_FORM } from 'modules/Taps/components/NDFL3Light/constants';
import config from 'config';
import { remotePaths } from 'router/routes';

export default function* submitInitialDataSaga({ payload: { reportYear, step } }) {
  const state = yield select();
  const draft = selectDraft(state);
  const reportMode = selectDraftMode(state);
  const formData = getFormValues(STEP_INITIAL_FORM)(state);
  const parentDeclaration = selectParentDeclaration(state);
  const parentDeclarationData = parentDeclaration.get('data');
  const parentCardId = parentDeclarationData && parentDeclarationData.get('cardId');
  const isExternal = parentDeclarationData && parentDeclarationData.get('external');
  const useParent = formData.get('useParent');
  const phone = formData.get('phone');

  //  if is creation mode, parent declaration is found and declaration is external
  //  (cardId = null, or payload.external flag is true) or data not found
  //  and isClarification is set - go to the full scenario
  if (
    !draft &&
    ((parentDeclarationData && useParent && (!parentCardId || isExternal)) ||
      (!parentDeclarationData && formData.get('isClarification')))
  ) {
    return yield config.goToNewLK(remotePaths.situations);
  }

  // if is creation mode (no draft presented) - create new draft
  if (!draft) {
    const cardDraft = {};

    // refine declaration and set parent card originalData if parent declaration is found
    if (parentCardId && useParent) {
      yield put(refineDraft(parentCardId));
      const { payload: cardId } = yield take(REFINE_DRAFT_SUCCESS);

      yield put(getDraft(cardId));
      const { payload } = yield take(GET_DRAFT_SUCCESS);

      Object.assign(cardDraft, payload);
      // set parent declaration data
      set(cardDraft, 'cardId', cardId);
      set(cardDraft, 'mode', reportMode);
      set(cardDraft, 'payload.initialData.firstSubmit', false);
    } else {
      // create new declaration if parent declaration is not found
      yield put(createDraft(reportYear, reportMode));
      const { payload } = yield take(CREATE_DRAFT_SUCCESS);

      Object.assign(cardDraft, payload);
      set(cardDraft, 'payload.originalData.usePrevSentDeclaration', false);
    }

    set(cardDraft, 'payload.initialData.phone', phone);
    yield put(updateDraft({ draft: fromJS(cardDraft) }));
    const { payload: { cardId } = {} } = yield take(UPDATE_DRAFT_SUCCESS);

    yield put(replace({ query: { cardId, step } }));
  } else {
    const nDraft = draft.setIn(['payload', 'initialData', 'phone'], phone);
    // setIn(draft, ['payload','initialData','phone'], phone);
    yield put(updateDraft({ draft: nDraft }));
    yield take(UPDATE_DRAFT_SUCCESS);
    // if is edit mode - go to next step, nothing to save
    yield put(push({ query: { cardId: draft.get('cardId'), step } }));
  }
  return yield put(submitInitialDataSuccess());
}
